
import React from 'react';
import { daypartOpportunities, daypartInsights } from './daypartData';
import { Clock, Coffee, Utensils, Car, Truck, Route, Moon, Tractor, Home, ShoppingBasket, School, ShoppingCart } from 'lucide-react';

const DaypartOpportunities = ({ segmentId }) => {
  const opportunities = daypartOpportunities[segmentId] || daypartOpportunities.urban;
  const insight = daypartInsights[segmentId] || daypartInsights.urban;
  
  // Map for icon components
  const iconMap = {
    coffee: Coffee,
    utensils: Utensils,
    car: Car,
    truck: Truck,
    route: Route,
    moon: Moon,
    tractor: Tractor,
    home: Home,
    'shopping-basket': ShoppingBasket,
    school: School,
    'shopping-cart': ShoppingCart
  };
  
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
      <h3 className="text-md font-medium text-gray-900 mb-4">Key Daypart Opportunities</h3>
      
      <div className="space-y-4">
        {opportunities.map((opportunity, index) => {
          const IconComponent = iconMap[opportunity.icon] || Clock;
          
          return (
            <div 
              key={index} 
              className="flex items-start p-3 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors"
            >
              <div className="p-2 bg-white rounded-lg shadow-sm mr-3">
                <IconComponent size={18} className="text-purple-600" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-purple-900">{opportunity.title}</h4>
                <p className="text-xs text-gray-700 mt-1">{opportunity.description}</p>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="mt-6 p-3 bg-blue-50 border-l-4 border-blue-400 rounded-r-md">
        <p className="text-sm text-blue-800">
          <span className="font-medium">Insight:</span> {insight}
        </p>
      </div>
    </div>
  );
};

export default DaypartOpportunities;
